import React, { useState } from 'react';
import axios from 'axios';

function CallCostsChecker() {
  const [number, setNumber] = useState('');
  const [callRates, setCallRates] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showTable, setShowTable] = useState(false);

  const getPencePerMin = (price: any) => {
    const countries = require('../data/localisation.json');
    const countryCode = localStorage.getItem('country') || 'GB';

    return price === 0 ? 'FREE' : `${price}${countries[countryCode].pence}`;
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(
        `https://api-gb-cl-aws.gammaapi.net/admin/circleloop/numbers/rate?number=${number}`,
      );
      const data = response.data;

      const paygPrice = getPencePerMin(data.paygPencePerMinute);
      const unlimitedPrice = getPencePerMin(data.pencePerMinute);
      setCallRates([{ ...data, paygPrice, unlimitedPrice }]);
      setShowTable(true);
    } catch (error) {
      setError('Number not found, please try again.');
      setShowTable(false);
    }
    setLoading(false);
  };

  const handleChange = (e: any) => {
    setNumber(e.target.value);

    if (e.target.value === ' ' || !e.target.value) {
      setShowTable(false);
    }
  };
  return (
    <div>
      <form className='mb-6 js-check-number' onSubmit={handleSubmit}>
        <div className='relative w-full mx-auto my-7 lg:w-60'>
          <input
            id='id-b15'
            className='relative w-full h-10 px-4 pl-10 text-sm placeholder-transparent transition-all border-b outline-none focus-visible:outline-none peer border-neutral-700 text-neutral-700 autofill:bg-white invalid:text-primary-500 focus:border-neutral-900 focus:outline-none disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400'
            name='number'
            type='text'
            placeholder='Enter Phone Number'
            pattern='^[\s\d]{8,}$'
            title='Please enter the full number'
            required
            onChange={handleChange}
            value={number}
            disabled={loading}
          />
          <button
            type='submit'
            className='absolute top-2.5 left-2 cursor-pointer stroke-neutral-700 peer-disabled:cursor-not-allowed z-10'
            id='submit-phone-number'
            disabled={loading}
          >
            {!loading && (
              <svg
                className='w-5 h-5 '
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
                strokeWidth='1.5'
                aria-hidden='true'
                aria-labelledby='title-10 description-10'
                role='graphics-symbol'
              >
                <title id='title-10'>Search icon</title>
                <desc id='description-10'>Icon description here</desc>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z'
                />
              </svg>
            )}
            {loading && (
              <svg
                className='w-4 h-4 animate-spin'
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                role='graphics-symbol'
                aria-labelledby='title-15 desc-15'
                stroke='currentColor'
              >
                <title id='title-15'>Icon title</title>
                <desc id='desc-15'>A more detailed description of the icon</desc>
                <circle
                  className='opacity-25 '
                  cx='12'
                  cy='12'
                  r='10'
                  stroke='currentColor'
                  strokeWidth='4'
                ></circle>
                <path
                  className='opacity-75 !stroke-neutral-500'
                  fill='currentColor'
                  d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
                ></path>
              </svg>
            )}
          </button>
          <button
            type='button'
            id='clear-call-cost-checker'
            onClick={() => {
              setNumber('');
              setCallRates([]);
              setShowTable(false);
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
              strokeWidth='1.5'
              className='absolute top-2.5 right-4 h-5 w-5 cursor-pointer stroke-neutral-900  peer-disabled:cursor-not-allowed'
              aria-labelledby='title-10 description-10'
              role='graphics-symbol'
            >
              <title id='title-10'>X icon</title>
              <desc id='description-10'>Icon description here</desc>
              <path strokeLinecap='round' strokeLinejoin='round' d='M6 18 18 6M6 6l12 12' />
            </svg>
          </button>

          {error && (
            <small className='absolute flex justify-between w-full px-4 py-1 text-xs transition text-primary-500'>
              <span>{error}</span>
            </small>
          )}
        </div>
      </form>
      <div className={`cl-table-container ${showTable ? 'block' : 'hidden'}`}>
        <table id='rates-table'>
          <thead>
            <tr>
              <th>Country Name</th>
              <th>Unlimited Plan - Per Min</th>
              <th>PAYG Plan - Per Min</th>
            </tr>
          </thead>
          <tbody>
            {callRates.map((rate) => (
              <tr key={rate.countryName}>
                <td className='flex flex-col gap-3 border-t-0 border-r-0 lg:items-center lg:flex-row'>
                  <span>
                    <img
                      className='w-5 h-5'
                      src={`https://s3-eu-west-1.amazonaws.com/circleloop-assets/images/pricing/flags/${rate.flag}`}
                      alt='Flag'
                    />
                  </span>
                  <span>{rate.countryName}</span>
                </td>
                <td className='country-price'>{rate.unlimitedPrice}</td>
                <td className='country-price'>{rate.paygPrice}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default CallCostsChecker;
